import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import RichTextEditor from "react-rte";
import { Button } from "reactstrap";
import moment from "moment";
import { API_END_POINT } from "../config";
import CKEditor from "ckeditor4-react";

const token = localStorage.getItem("token");

export default class NotificationsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      notification: {
        title: "",
        notificationText: "",
      },
      notificationText: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.postNotification = this.postNotification.bind(this);
    this.onEditorChange = this.onEditorChange.bind(this);
  }

  componentDidMount() {
    const { match } = this.props;
    // if (match.params.blogId) {
    //   axios
    //     .get(`${API_END_POINT}/api/blog/one/${match.params.blogId}`, {
    //       headers: { "auth-token": token },
    //     })
    //     .then((response) => {
    //       console.log("response", response.data.data);
    //       this.setState({
    //         blog: response.data.data,
    //         blogText: response.data.data.blogText,
    //       });
    //     });
    // }
  }

  onEditorChange(evt) {
    // var blogText = this.state.blog.blogText;
    this.setState({
      notificationText: evt.editor.getData(),
    });
    console.log(this.state);
  }

  handleInputChange(event) {
    const { value, name } = event.target;

    const { notification } = this.state;
    notification[name] = value;
    this.setState({ notification });
  }

  // handleImages = (event) => {
  //   this.setState({ blog: event.target.files[0] });
  // }

  postNotification(evt) {
    evt.preventDefault();
    const { notification, notificationText } = this.state;

    this.setState({ loading: true });
    const notificationData = {
      title: notification.title,
      body: notification.desc, // Ändere 'bodyText' zu 'body' um konsistent mit der vorherigen API zu sein
    };
    const fd = new FormData();
    fd.append("title", notification.title);
    fd.append("bodyText", notification.desc);

    axios
      .post(`${API_END_POINT}/api/pushnotifications`, notificationData, {
        headers: {
          "auth-token": token,
          "Content-Type": "application/json", // Setze den Header für JSON
        },
      })
      .then((response) => {
        console.log(response, "responsenoti");
        if (response.status === 200) {
          window.alert(response.data.message);
          this.setState({ loading: false });
          this.props.history.goBack();
        } else {
          window.alert("ERROR");
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.error("Error during notification post:", error);
        window.alert("ERROR");
        this.setState({ loading: false });
      });
  }

  render() {
    const { loading, blog, blogText, notification, notificationText } =
      this.state;
    const toolbarConfig = {
      // Optionally specify the groups to display (displayed in the order listed).
      display: [
        "INLINE_STYLE_BUTTONS",
        "BLOCK_TYPE_BUTTONS",
        "HISTORY_BUTTONS",
        "BLOCK_TYPE_DROPDOWN",
      ],
      INLINE_STYLE_BUTTONS: [
        {
          label: "Bold",
          style: "BOLD",
          className: "custom-css-class",
        },
        {
          label: "Italic",
          style: "ITALIC",
        },
        {
          label: "Underline",
          style: "UNDERLINE",
        },
      ],
      BLOCK_TYPE_DROPDOWN: [
        {
          label: "Normal",
          style: "unstyled",
        },
        {
          label: "Large Heading",
          style: "header-three",
        },
        {
          label: "Medium Heading",
          style: "header-four",
        },
        {
          label: "Small Heading",
          style: "header-five",
        },
      ],
      BLOCK_TYPE_BUTTONS: [
        {
          label: "UL",
          style: "unordered-list-item",
        },
        {
          label: "OL",
          style: "ordered-list-item",
        },
      ],
    };
    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title">
                  <h2>Benachrichtigung anlegen:</h2>
                </div>
                <div className="x_content">
                  <br />
                  <form
                    id="demo-form2"
                    data-parsley-validate
                    className="form-horizontal form-label-left"
                    onSubmit={this.postNotification}
                  >
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Titel der Benachrichtigung
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="title"
                          className="form-control"
                          value={notification.title}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    {/* <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Image
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          type="file"
                          accept="image/*"
                          name="image"
                          className="form-control"
                          onChange={this.handleImages}
                          // multiple
                          required={
                            this.props.match.params.blogId ? false : true
                          }
                        />
                      </div>
                    </div> */}

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Benachrichtigungstext
                      </label>
                      {/* <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="blogText"
                          className="form-control"
                          value={blog.blogText}
                          onChange={this.handleInputChange}
                        />
                      </div> */}
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="desc"
                          className="form-control"
                          value={notification.desc}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="ln_solid" />
                    <div className="form-group row">
                      <div className="col-md-6 col-sm-6 offset-md-3">
                        <Button
                          className={`btn btn-success btn-lg ${
                            this.state.loading ? "disabled" : ""
                          }`}
                        >
                          <i
                            className={`fa fa-spinner fa-pulse ${
                              this.state.loading ? "" : "d-none"
                            }`}
                          />{" "}
                          Bestätigen
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotificationsForm.jsx